export default {"src":"/_next/static/media/review.3008f83d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};